import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const C = { bg: "#ffffff", text: "#000000", accent: "#52658F", muted: "#555555", border: "#e0e0e0", peach: "#ECDBC9" };
const SYNE = "'Fraunces', serif";
const MONO = "'Plus Jakarta Sans', sans-serif";
const FONT_LINK = "https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,700;9..144,800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap";

export default function NotFound() {
    const navigate = useNavigate();

    useEffect(() => {
        if (!document.querySelector('link[href*="Fraunces"]')) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = FONT_LINK;
            document.head.appendChild(link);
        }
    }, []);

    return (
        <div style={{ background: C.bg, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "1rem", fontFamily: MONO, textAlign: "center", padding: "2rem" }}>
            <div style={{ fontFamily: SYNE, fontSize: "6rem", fontWeight: 800, color: C.accent, opacity: 0.15, lineHeight: 1 }}>404</div>
            <h1 style={{ fontFamily: SYNE, fontWeight: 800, fontSize: "1.75rem", color: C.text, marginTop: "-0.5rem" }}>Page not found</h1>
            <p style={{ color: C.muted, maxWidth: 340, lineHeight: 1.7 }}>This row doesn't exist in either file — and unlike your data, we can't reconcile it.</p>
            <button
                onClick={() => navigate("/")}
                style={{ background: C.accent, color: "white", border: "none", padding: "0.75rem 1.5rem", borderRadius: 8, fontFamily: SYNE, fontWeight: 700, cursor: "pointer", marginTop: "0.5rem" }}>
                ← Back to DGB
            </button>
        </div>
    );
}
